import React from 'react';
import './index.css'
import { FaUnity } from "react-icons/fa6";
import { FaMeta } from "react-icons/fa6";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";

const references = [
    {
        title: "From Dystopia to Eutopia: Transforming Urban Environments Through Collaborative Decision-Making in ARSINOE VR",
        url: "#",
        description: "The Scientific Paper that was submitted in IEEE VR - 3DUI Contest. Authors: Giorgos Ganias, Christos Lougiakis, Anastasios Niarchos, Akrivi Katifori, Dimitra Petousi, Marina Stergiou, Gabriel Gourdoglou, Maria Roussou, Yannis Ioannidis"
    },
    {
        title: "IEEE VR 3DUI Contest 2025",
        url: "https://ieeevr.org/2025/contribute/3dui-contest/",
        description: "The IEEE VR 3DUI Contest is an international competition that showcases innovative applications of virtual and augmented reality in education and inclusion, encouraging researchers and developers to create immersive experiences that enhance learning and accessibility."
    },
];

const contactUs = [
    {
        title: "Address: Αιγιαλείας 19 &, Chalepa, Marousi 151 25",
        url: "#",
        description: "ATHENA Research Center, Aigialeias 19 & Chalepa, Marousi, 151 25"
    },
    {
        title: "Address: Ilissia, Athens, 157 84",
        url: "#",
        description: "Department of Informatics and Telecommunications, Ilissia, Athens, 157 84"
    },
    {
        title: "Email",
        url: "#",
        description: "narralive.athenarc@gmail.com"
    },
    {
        title: "Telephone",
        url: "#",
        description: "+30 210 727-5339"
    }
];

const ReferencesPage = () => {
    return (
        <div>
            {/*Team Section
            <div className="font-sans bg-[#111827] pb-14">
                    <h1 className='text-[40px] p-5 text-left font-bold text-white flex justify-center'>
                        TEAM
                    </h1>
                    <div className="flex justify-center items-center gap-x-5 text-black">
                        
                        <div className="w-[250px] h-[380px] bg-white rounded-xl flex items-start relative overflow-hidden dropsample">
                            <div className="w-auto h-full">
                                <img
                                alt="logo" 
                                src={imgGiorgos} 
                                width="250"/>
                                <div className="p-3">
                                    <h1 className="text-[24px] text-center font-bold">George Ganias</h1>
                                    <h2 className="text-[17px] text-center">Software Development</h2>
                                </div>
                                
                            </div>
                        </div>
                        <div className="w-[250px] h-[380px] bg-white rounded-xl flex items-start relative overflow-hidden dropsample">
                            <div className="w-auto h-full">
                                <img 
                                alt="logo"
                                src={imgGiorgos}
                                width="250"/>
                                <div className="p-3">
                                    <h1 className="text-[24px] text-center font-bold">Allos Enas</h1>
                                    <h2 className="text-[17px] text-center">Software Development</h2>
                                </div>
                                
                            </div>
                        </div>
                        <div className="w-[250px] h-[380px] bg-white rounded-xl flex items-start relative overflow-hidden dropsample">
                            <div className="w-auto h-full">
                                <img 
                                alt="Giorgos"
                                src={imgGiorgos} 
                                width="250"/>
                                <div className="p-3">
                                    <h1 className="text-[24px] text-center font-bold">Kapoios Allos</h1>
                                    <h2 className="text-[17px] text-center">Software Development</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            */}
            <div className="font-sans bg-[#111827] h-full flex justify-center items-start">

                <div className='w-[50%]'>
                    <div className='mt-10'>
                        <h1 className='text-blue text-[40px] pb-10 text-left font-bold text-white flex justify-center'>
                            TOOLS
                        </h1>
                        <div className='flex justify-center items-center space-x-14 pb-14'>
                            <div className='text-white text-center w-fit flex flex-col items-center'>
                                <FaUnity className='text-[60px] bg-blue-500 p-4 rounded-full' />
                                <p className='mt-2'>Unity</p>
                            </div>
                            <div className='text-white text-center w-fit flex flex-col items-center'>
                                <FaMeta className='text-[60px] bg-blue-500 p-4 rounded-full' />
                                <p className='mt-2'>Meta SDK</p>
                            </div>
                        </div>
                    </div>
                    <h1 className='text-blue text-[40px] p-5 text-left font-bold text-white flex justify-center'>
                        REFERENCES
                    </h1>
                    <ul className="list-none p-5">
                    {references.map((ref, index) => (
                            <li key={index} className="mb-4">
                                <a 
                                    href={ref.url} 
                                    className="text-xl text-blue-500 hover:underline" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    {ref.title}
                                </a>
                                <p className="text-white text-justify" >{ref.description}</p>
                            </li>
                        ))}
                    </ul>
                    <h1 className='text-blue text-[40px] p-5 text-left font-bold text-white flex justify-center'>
                        CONTACT US 
                    </h1>
                    <div className="bg-[#1E293B] p-6 rounded-xl shadow-lg mx-5 mb-10">
                        <ul className="list-none space-y-4">
                            {contactUs.map((contact, index) => (
                                <li key={index} className="flex items-center justify-center space-x-3">
                                    {/* Icon right next to text */}
                                    {contact.title.includes("Address") && <FaMapMarkerAlt className="text-blue-500 text-2xl" />}
                                    {contact.title.includes("Email") && <FaEnvelope className="text-blue-500 text-2xl" />}
                                    {contact.title.includes("Telephone") && <FaPhone className="text-blue-500 text-2xl" />}

                                    {/* Text aligned directly beside the icon */}
                                    <a 
                                        href={contact.title.includes("Email") ? `mailto:${contact.description}` : 
                                            contact.title.includes("Telephone") ? `tel:${contact.description}` : "#"} 
                                        className="text-blue-400 hover:underline text-lg"
                                    >
                                        {contact.description}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReferencesPage;
